<template>
	<div class="msg-analysis-voice msg-analysis-voice-me" v-if="msg.is_me == 1">
		<span class="msg-analysis-voice-time" style="margin-right: 5px;">{{message.voiceTime}}″</span>
		<span class="msg-analysis-voice-s"></span>
	</div>
	<div class="msg-analysis-voice" v-else>
		<span class="msg-analysis-voice-s"></span>
		<span class="msg-analysis-voice-time" style="margin-left: 5px;">{{message.voiceTime}}″</span>
	</div>
</template>

<script>
	import AppConfig from '../../../config/AppConfig.js'
	export default{
		name: 'MsgAnalysisVoice',
		components:{
			
		},
		props:{
			msg:{
				  type:Object,
				  default:function(){
					  return {}
				  }
			}
		},
		data(){
			return {
				message: {}
			}
		},
		methods:{
			format(){
				let message = this.msg.content
				try {
					message = JSON.parse(message)
				}catch (e) {
					message = {
						voiceUrl: message,
						voiceTime: 0
					}
				}
				if(message.voiceUrl.indexOf('http') === -1){
					message.voiceUrl = AppConfig.host + message
				}
				let time = Math.round(message.voiceTime / 1000)
				message.voiceTime = time
				this.message = message
			}
		},
		
		created() {
			this.format()
		}
	}
</script>

<style>
	.msg-analysis-voice{
		background-color: #EEEEEE;
		padding: 6px 10px;
		border-radius: 2px;
		position: relative;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.msg-analysis-voice::before{
		content: '';
		display: block;
		background-color: #EEEEEE;
		width: 12px;
		height: 12px;
		position: absolute;
		top: 8px;
		left: -6px;
		transform: rotateZ(45deg);
	}
	.msg-analysis-voice-s{
		display: inline-block;
		height: 22px;
		width: 22px;
		background: url("/img/icon.png") -200px -432px;
		vertical-align: middle;
		cursor: pointer;
	}
	.comp-chatting-c-playing .chat-detail-msg .msg-analysis-voice-s{
		background: url("/img/playing_receive_voice.gif") 0 0 !important;
	}
	.msg-analysis-voice-me{
		background-color: #b2e281 !important;
	}
	.msg-analysis-voice-me::before{
		background-color: #b2e281;
		right: -6px;
		left: unset;
	}
	.msg-analysis-voice-me .msg-analysis-voice-s{
		display: inline-block;
		height: 22px;
		width: 22px;
		background: url("/img/icon.png") -464px -398px;
		vertical-align: middle;
		cursor: pointer;
	}
	.comp-chatting-c-playing .msg-analysis-voice-me .msg-analysis-voice-s{
		background: url("/img/playing_send_voice.gif") 0 0 !important;
	}
</style>
